<template>
  <el-form-item>
    <template #label>
      <span
        >{{ i18nt('designer.setting.fileTypes') }}
        <el-tooltip effect="light" :content="i18nt('designer.setting.fileTypesHelp')"> <i class="el-icon-info"></i></el-tooltip>
      </span>
    </template>
    <el-select multiple allow-create filterable default-first-option v-model="optionModel.fileTypes" style="width: 100%">
      <el-option v-for="(ft, ftIdx) in uploadFileTypes" :key="ftIdx" :label="ft.label" :value="ft.value"> </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { reactive, toRefs } from 'vue';
import { useI18n } from '@/utils/i18n';

export default {
  name: 'm-file-upload-fileTypes-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    // 新增的文件类型可能无法找到对应的MIME类型，请在utils/util.js 的mimeTypes中添加
    const data = reactive({
      uploadFileTypes: [
        { label: 'doc', value: 'doc' },
        { label: 'xls', value: 'xls' },
        { label: 'docx', value: 'docx' },
        { label: 'xlsx', value: 'xlsx' },
        { label: 'pdf', value: 'pdf' },
      ],
    });

    return {
      i18nt,
      ...toRefs(props),
      ...toRefs(data),
    };
  },
};
</script>

<style scoped></style>
